// extracted by mini-css-extract-plugin
export default {"checkbox":"QeZXA","setting":"Y0Gqw"};